<template>
  <v-row class="ma-0">
    <v-col>
      <div v-if="zones.zonesChanges.missing.length < 1" class="no-zone">
        <span>{{ $t('map.tolldomains.overview.no_missing_zones') }}</span>
        <img :src="require('@/assets/images/overview-world-empty.svg')" alt="overview-world-empty" />
      </div>
      <div v-if="zones.zonesChanges.missing.length > 0" class="map-container">
        <l-map
          v-if="mapLoaded && index === 3"
          ref="missing-zones-map"
          :options="{ preferCanvas: true }"
          @ready="onMapReady"
        >
          <l-tile-layer v-bind="tilesOpts" />
        </l-map>
      </div>
    </v-col>
    <v-col class="col-5 pa-0 overview-container">
      <span class="confirm-zones">{{ $t('map.tolldomains.overview.confirm_missing_zones_1') }}<br>
        {{ $t('map.tolldomains.overview.confirm_missing_zones_2') }}</span>
      <v-row class="list-card">
        <v-col class="pa-0">
          <v-row class="ma-0">
            <div class="list-card-title mb-3">{{ $t('map.tolldomains.overview.missing_zones_list') }}</div>
          </v-row>
          <v-row class="ma-0">
            <div v-if="zones.zonesChanges.missing.length > 0" class="list-container">
              <div class="column-header">
                <span>&nbsp;</span>
                <span>{{ $t('map.tolldomains.global_information.identifier') }}</span>
                <span>{{ $t('map.tolldomains.global_information.tsp_code') }}</span>
                <span>{{ $t('map.tolldomains.global_information.country_code') }}</span>
                <span>{{ $t('map.tolldomains.global_information.provider_identifier') }}</span>
                <span>&nbsp;</span>
              </div>
            </div>
          </v-row>
          <v-row class="ma-0">
            <div v-if="zones.zonesChanges.missing.length > 0" class="list-container">
              <div v-for="(zone, index) in zones.zonesChanges.missing" :key="zone.code" class="list-item-container">
                <span><v-icon color="red">mdi-alert-outline</v-icon></span>
                <span>{{ zone.id }}</span>
                <span class="text-capitalize">{{ zone.name }}</span>
                <span class="text-uppercase">{{ zone.code }}</span>
                <span>{{ zone.providerId || 0 }}</span>
                <span class="zoneVisibility" :class="[zoneVisibility[index] ? 'zoneActive' : 'zoneInactive']" @click="displayMap(zone.code, index)" />
              </div>
            </div>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import L from 'leaflet';
import { LMap, LTileLayer } from 'vue2-leaflet';
import { MAP_ATTRIBUTION, TILES_URL } from '@/constants/map/mapConstants';
import { GeoJsonObject } from 'geojson';

@Component({
  components: {
    LMap,
    LTileLayer
  }
})
export default class OverviewMissingZones extends Vue {
  @Prop()
  private index!: number;

  @Prop()
  private zones!: any;

  @Prop()
  private mapLoaded!: boolean;

  private geoGroup: L.FeatureGroup;

  private zoneVisibility:boolean[] = [];

  private map: L.Map;

  private tilesOpts = {
    url: TILES_URL,
    attribution: MAP_ATTRIBUTION
  };

  private layerStyle = {
    color: '#eb4034',
    weight: 2,
    opacity: 1
  };

  private layers: any = {};

  private onMapReady() {
    if (this.zones.zonesChanges.missing.length > 0) {
      const mapComponent = this.$refs['missing-zones-map'] as LMap;
      mapComponent.mapObject.invalidateSize();
      this.geoGroup = L.featureGroup();
      this.map = mapComponent.mapObject;
      this.zoneVisibility = Array(this.zones.zonesChanges.missing.length).fill(true);
      this.zones.zonesChanges.missing.forEach((zone: any) => {
        const geo = JSON.parse(zone.geo);
        this.addLayer(zone.code, geo);
      });
      this.map.fitBounds(this.geoGroup.getBounds());
    }
  }

  private displayMap(id: string, index: number) {
    this.$set(this.zoneVisibility, index, !this.zoneVisibility[index]);
    if (this.layers[id].toggle) {
      this.layers[id].map.remove();
    } else {
      this.layers[id].map.addTo(this.map);
    }
    this.layers[id].toggle = !this.layers[id].toggle;
  }

  private addLayer(name: string, map: GeoJsonObject) {
    const layer = L.geoJSON(map, { style: this.layerStyle }).addTo(this.map);
    this.geoGroup.addLayer(layer);
    this.layers[name] = { toggle: true, map: layer };
  }
}
</script>
<style lang="scss" scoped>
@import './styles/overview-missing-zones.scss';
</style>
